import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import Checkbox from "../../../../components/Checkbox/Index";
import Row from "./row";
import useProcessorStore from "../../../../stores/processor";
import SkeletonRow from "../../../../components/skeleton-loader/table/row";

const Table = ({ data, fetchData }) => {
  const selectedBanks = useProcessorStore((state) => state.selectedBanks);
  const setSelectedBanks = useProcessorStore((state) => state.setSelectedBanks);
  const searchQuery = useProcessorStore((state) => state.searchQuery);
  const setSearchQuery = useProcessorStore((state) => state.setSearchQuery);
  const isLoading = useProcessorStore((state) => state.isLoading);
  const setIsLoading = useProcessorStore((state) => state.setIsLoading);


  const onSelectAll = (event) => {
    if (event?.target?.checked) {
      setSelectedBanks(data?.map((item) => String(item?.id)));
    } else {
      setSelectedBanks([]);
    }
  };

  const handleSort = (orderBy) => {
    setSearchQuery({
      ...searchQuery,
      orderBy: orderBy,
      order: searchQuery?.order == 'asc' ? 'desc' : 'asc',
    });
  }

  return (
    <table className={styles.table}>
      <thead className={styles.thead}>
        <tr className={styles.theadRow}>
          <th className={`${styles.th} ${styles.w40p}`}>
            <Checkbox
              checked={
                selectedBanks?.length === data?.length && data?.length > 0
              }
              onChange={onSelectAll}
            />
          </th>
          <th className={`${styles.th} ${styles.w140p}`} onClick={() => handleSort('id')} title="Click to sort" >
            <div className={styles.flex} >
              <span>SERIAL NO</span>
              {searchQuery.orderBy == 'id' && (
                <span>
                  {searchQuery.order == 'asc' ? '↓' : '↑'}
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th}`} onClick={() => handleSort('name')} title="Click to sort" >
            <div className={styles.flex} >
              <span>Name</span>
              {searchQuery.orderBy == 'name' && (
                <span>
                  {searchQuery.order == 'asc' ? '↓' : '↑'}
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140p}`} onClick={() => handleSort('status')} title="Click to sort" >
            <div className={styles.flex} >
              <span>Status</span>
              {searchQuery.orderBy == 'status' && (
                <span>
                  {searchQuery.order == 'asc' ? '↓' : '↑'}
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w40p}`}></th>
        </tr>
      </thead>
      <tbody className={styles.tbody}>
        {isLoading ? (
          Array.from({ length: 8 }).map((_, index) => (
            <SkeletonRow key={`skeleton-${index}`} columnLength={5} />
          ))
        ) : (
          <>
            {data?.length > 0 ? (
              data?.map((item, index) => (
                <Row key={index} data={item} fetchData={fetchData} />
              ))
            ) : (
              <tr>
                <td colSpan="5" ><p className={styles.empty} >No data to display</p></td>
              </tr>
            )}
          </>
        )}
      </tbody>
    </table>
  );
};

export default Table;
